export default __webpack_public_path__ + "static/media/set_remote_sp_icon.3aa4cef0.svg";